import store from "../../store/store"
import { ChannelsHub } from "../hubs/channels"

export const channelsHub = new ChannelsHub(store)
